module.exports = function(number) {
    let value = number;
    if (typeof value !== 'number') {
        value = parseFloat(number);
    }
    return value.toFixed(2);
};